import {
    CreateCaregiverBodyIds,
    HcsDelegateRoleRefIds,
    HcsPositionRefIds,
    ProfessionRefIds,
    QualificationRefIds,
    usePostIdsHealthcareservicesHcsIdCaregivers,
} from '@toktokdoctech/tokapi-client'
import { useCallback } from 'react'
import { defaultValues, UserFormContextProvider } from './utils/userFormContext'
import { UserFormErrorContextProvider, defaultUserErrorValues } from './utils/userFormErrorContext'
import useCurrentHcs from '../../hooks/useCurrentHcs'
import { ERROR_MESSAGE } from '../../utils/ttdError'
import { CaregiverForm } from './CaregiverForm'
import { emptyData } from './userFormData'
import { UserData } from './_props'
import { buildCommonFields } from './utils/addOrUpdateUser/updatePayloadBuilders'

export const CaregiverCreation = () => {
    const { id: hcsId } = useCurrentHcs()
    const postCaregiver = usePostIdsHealthcareservicesHcsIdCaregivers()

    const handleSave = useCallback(
        async (userData: UserData) => {
            if (!userData.role?.id) throw new Error(ERROR_MESSAGE.MISSING_ROLE)

            const { identity, rppsNum, adeliNum, speciality, speMentions } = buildCommonFields(userData)

            const profession: ProfessionRefIds = { id: userData.professionId ?? '', name: userData.profession }

            const qualification: QualificationRefIds = {
                id: userData.qualificationId ?? '',
                name: userData.qualification,
            }

            const position: HcsPositionRefIds = userData.positionId
                ? { id: userData.positionId, name: userData.positionName ?? '' }
                : null

            const role: HcsDelegateRoleRefIds = { id: userData.role.id, name: userData.role.name ?? '' }

            const payload: CreateCaregiverBodyIds = {
                ...identity,
                rpps: rppsNum ?? adeliNum ?? null,
                profession,
                qualification,
                speciality,
                speMentions: speMentions.length > 0 ? speMentions : undefined,
                position,
                category: userData.category ?? '',
                email: userData.email,
                securedEmail: userData.securedEmail ?? null,
                privatePhone: userData.privatePhone ?? null,
                contactPhone: userData.contactPhone ?? null,
                role,
                internalUserPassword: userData.password || null,
            }

            await postCaregiver.mutateAsync({ hcsId, data: payload })
        },
        [hcsId, postCaregiver],
    )

    return (
        <UserFormContextProvider initialValues={defaultValues}>
            <UserFormErrorContextProvider initialValues={defaultUserErrorValues}>
                <CaregiverForm mode="CREATION" data={emptyData} onSave={handleSave} />
            </UserFormErrorContextProvider>
        </UserFormContextProvider>
    )
}
